class Author {
  constructor(document = window.document) {
    this.blocks = document.querySelectorAll('[data-block="author"]');

    if (0 !== this.blocks.length) {
      this.blocks.forEach(block => {
        new Block(block);
      });
    }
  }
}

class Block {
  constructor(block) {
    this.el = $(block);
  }
}

$(document).on(`bvm_front_ready`, () => {
  new Author();
});

$(document).on('bvm_blocks_author_init', (event, document) =>  {
  if ('function' === typeof document.querySelectorAll) {
    new Author(document);
  }
})
